<template>
  <app-side-menu>
    <aside class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input class="input uppercase"
                type="text"
                placeholder="Company Name"
                v-model="innerValue.companyName"
                @keyup="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input is-capitalized"
                type="text"
                placeholder="ABN"
                v-model="innerValue.abn"
                @keyup="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <google-suburb-autocomplete v-model="innerValue.suburb"
                @input="onFilterClick" />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="innerValue.countryCode"
                  @change="onFilterClick()">
                  <option value="null"
                    disabled>Select Country</option>
                  <option v-for="(country) in countries"
                    :key="country.countryCode"
                    :value="country.countryCode">
                    {{ country.countryDesc }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="innerValue.isHq"
                  @change="onFilterClick()">
                  <option value="null"
                    disabled>Select HQ</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
            </div>
          </div>

          <div v-if="flexiquoteModule"
            class="field multi-module-select">
            <div class="control">
              <multiselect v-model="moduleOptions"
                @select="onModuleSelect"
                @remove="onModuleRemove"
                :options="flexiquoteModule"
                :hide-selected="true"
                :multiple="true"
                :close-on-select="false"
                :show-labels="false"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Select Modules"
                label="modDesc"
                track-by="flexiQuoteModuleId"
                :taggable="true">
                <template slot="option"
                  slot-scope="props">
                  {{ props.option.modDesc }}
                </template>
              </multiselect>
            </div>
          </div>
          <div class="buttons has-addons">
            <span class="button"
              :class="{ 'is-primary is-selected' : innerValue.isActive === null}"
              @click="changeActive(null)">
              <span class="icon is-small">
                <span class="mso mso-16px">
                  adjust
                </span>
              </span>
              <span>Both</span>
            </span>
            <span class="button"
              :class="{ 'is-success is-selected' : innerValue.isActive === 1}"
              @click="changeActive(1)">
              <span class="icon is-small">
                <span class="mso mso-18px">check</span>
              </span>
              <span>Active</span>
            </span>
            <span class="button"
              :class="{ 'is-danger is-selected' : innerValue.isActive === 0}"
              @click="changeActive(0)">
              <span class="icon is-small">
                <span class="mso mso-18px">close</span>
              </span>
              <span>In-Active</span>
            </span>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <span class="mso mso-18px">search</span>
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button class="button"
            @click="onResetClick">
            <span class="icon">
              <span class="mso mso-18px">refresh</span>
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import _cloneDeep from 'lodash/cloneDeep'
import CompanyService from './CompanyService.js'
import Multiselect from 'vue-multiselect'
import GoogleSuburbAutocomplete from '@/components/Address/GoogleSuburbAutocomplete.vue'
import CountrySettingService from '../superadmin/countrysetting/CountrySettingService.js'

export default {
  name: 'CompanyListSideMenu',
  components: {
    AppSideMenu,
    Multiselect,
    GoogleSuburbAutocomplete
  },
  props: {
    filter: null,
    value: null
  },
  data() {
    return {
      innerValue: _cloneDeep(this.value),
      moduleOptions: [],
      selectedActive: 1,
      stateList: null,
      flexiquoteModule: null,
      countries: []
    }
  },
  computed: {},
  watch: {
    innerValue: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
    // value: {
    //   handler: function (newVal, oldVal) {
    //     debugger
    //     this.innerValue = oldVal
    //   },
    //   deep: true
    // }
  },
  async created() {
    this.flexiquoteModule = await CompanyService.getAllFlexiquoteModules()
    // Remap moduleOptions after flexiquoteModule is loaded
    if (Array.isArray(this.innerValue.modules) && this.innerValue.modules.length) {
      this.moduleOptions = this.innerValue.modules.map((id) => {
        if (typeof id === 'object') return id
        const obj = this.flexiquoteModule.find((m) => m.flexiQuoteModuleId === id)
        return obj ? obj : { flexiQuoteModuleId: id }
      })
    }
    this.getCountries()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onModuleSelect(selected) {
      // Add selected module object to moduleOptions if not present
      if (selected && !this.moduleOptions.some((m) => m.flexiQuoteModuleId === selected.flexiQuoteModuleId)) {
        this.moduleOptions.push(selected)
      }
      // Sync innerValue.modules to array of IDs
      this.innerValue.modules = this.moduleOptions.map((m) => m.flexiQuoteModuleId)
      this.onFilterClick()
    },
    onModuleRemove(removed) {
      this.innerValue.modules = this.moduleOptions.map((m) => m.flexiQuoteModuleId)
      this.onFilterClick()
    },
    onResetClick() {
      this.innerValue.modules = []
      this.moduleOptions = []
      this.$emit('reset')
    },
    changeActive(value) {
      this.innerValue.isActive = value
      this.onFilterClick()
    },
    async getCountries() {
      var filter = {
        query: '',
        active: 1,
        sortColumn: 'countryCode',
        sortOrder: 'asc',
        pageIndex: 1,
        pageSize: 18
      }
      const result = await CountrySettingService.getEntitySummaries(filter)
      this.countries = result
    }
  }
}
</script>

<style lang="scss" >
@use '@/assets/style/mixins/inputs/placeholder' as *;

input.is-uppercase {
  text-transform: uppercase;
  @include reset-placeholder-text-transform;
}

select.select-width {
  min-width: 15em;
}

.multiselect__tag {
  margin: 2px;
}

.multi-module-select {
  max-width: clamp(15vw, 18vw, 18vw);
}
</style>